var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransparancy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "29.092px",
    height: "29.092px",
    viewBox: "0 0 29.092 29.092",
    enableBackground: "new 0 0 29.092 29.092",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    transform: "translate(-864.081 -375.586)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_571",
    x: 865.581,
    y: 377.086,
    fill: "none",
    stroke: "#01C28D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 10.147,
    height: 10.147
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_572",
    x: 881.525,
    y: 377.086,
    fill: "none",
    stroke: "#01C28D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 10.147,
    height: 10.147
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_573",
    x: 865.581,
    y: 393.031,
    fill: "none",
    stroke: "#01C28D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 10.147,
    height: 10.146
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_574",
    x: 881.525,
    y: 393.031,
    fill: "none",
    stroke: "#01C28D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 10.147,
    height: 10.146
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparancy);
export default __webpack_public_path__ + "static/media/transparancy.64a97fb029b699ea453cf7697ade26c3.svg";
export { ForwardRef as ReactComponent };